import { render, staticRenderFns } from "./AuthEdit.vue?vue&type=template&id=72f51e6a&scoped=true&"
import script from "./AuthEdit.vue?vue&type=script&lang=js&"
export * from "./AuthEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f51e6a",
  null
  
)

export default component.exports